import { useState } from "react";
import DashboardTile from "../dashboard/DashboardTile";
import PriceFormat from "../../utils/priceFormat";
import { IUserPartDataStats } from "./EbayOrdersStats";

export default function OrderStatsTable({
  orderStats,
}: {
  orderStats: IUserPartDataStats[];
}) {
  return (
    <DashboardTile span={2}>
      <div className="">
        <div className="mb-4 flex items-center justify-between">
          <div className="prose">
            <h3 className="m-0">User Stats</h3>
          </div>
        </div>

        <div className="overflow-x-auto overflow-y-scroll max-h-[36vh]">
          <table className="min-w-full border-collapse">
            <thead>
              <tr className="border-b border-gray-300 text-left text-sm font-semibold text-gray-700">
                <th className="py-2 px-3 w-1/3">Full Name</th>

                <th className="py-2 px-3 text-right bg-green-200">Dispatched</th>
                <th className="py-2 px-3 text-right bg-green-200">Avg</th>

                <th className="py-2 px-3 text-right bg-blue-200">Picked</th>
                <th className="py-2 px-3 text-right bg-blue-200">Avg</th>

                <th className="py-2 px-3 text-right bg-pink-200">Packed</th>
                <th className="py-2 px-3 text-right bg-pink-200">Avg</th>

                {/* <th className="py-2 px-3 text-right">Returns Rate</th>
                <th className="py-2 px-3 text-right">Missing Rate</th> */}
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-200">
              {orderStats.length > 0 ? (
                orderStats.map((row: IUserPartDataStats) => (
                  <tr key={row.userId}>
                    <td className="py-2 px-3 font-medium text-gray-900">
                      {row.userFullName}
                    </td>

                    <td className="py-2 px-3 text-right font-semibold text-primary-600 bg-green-50">
                      {row.dispatched}
                    </td>
                    <td className="py-2 px-3 text-right font-semibold text-primary-600 bg-green-50">
                      {row.dailyAvgDispatched.toFixed(2)}
                    </td>

                    <td className="py-2 px-3 text-right font-semibold text-primary-600 bg-blue-50">
                      {row.picked}
                    </td>
                    <td className="py-2 px-3 text-right font-semibold text-primary-600 bg-blue-50">
                      {row.dailyAvgPicked.toFixed(2)}
                    </td>

                    <td className="py-2 px-3 text-right font-semibold text-primary-600 bg-pink-50">
                      {row.packed}
                    </td>
                    <td className="py-2 px-3 text-right font-semibold text-primary-600 bg-pink-50">
                      {row.dailyAvgPacked.toFixed(2)}
                    </td>

                    {/* <td className="py-2 px-3 text-right font-semibold text-primary-600">
                      {row.returnsRate.toFixed(2)}%
                    </td>
                    <td className="py-2 px-3 text-right font-semibold text-primary-600">
                      {row.missingRate.toFixed(2)}%
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={9} className="py-4 text-center text-gray-500 italic">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardTile>
  );
}